import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ProfileSurveyService } from '../../service/profile-survey/profile-survey.service';
import { ProfileSurvey } from '../../class/profile-survey';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { CustomerGuide } from '../../class/customer-guide';
import { ActivatedRoute } from '@angular/router';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { CustomerGuideService } from '../../service/customer-guide/customer-guide.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../../environments/config';

@Component({
  selector: 'app-profile-surveis',
  templateUrl: './profile-surveis.component.html',
  styleUrls: ['./profile-surveis.component.scss']
})
export class ProfileSurveisComponent implements OnInit {

    @Input() customerGuide: CustomerGuide;
    @ViewChild('gb') q_filter;
    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public profileSurveis: ProfileSurvey[];
    public selectProfileSurvey: ProfileSurvey;
    public profileSurveyID: Number = 0;
    public modNew = false;
    public modView = false;
    public openProfileSurvey = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public params_id_customer_guide: number;

    public form3: FormGroup;
    public company_id_filter: AbstractControl;

    public apiUrl = config.API_ROOT;

    public modExportDialog: boolean;

    public form4: FormGroup;
    public f4_company_id: AbstractControl;

    constructor(
        public profileSurveyService: ProfileSurveyService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        public hasPermissionService: HasPermissionService,
        public activatedRoute: ActivatedRoute,
        public infoGuideService: CustomerGuideService,
        fb: FormBuilder) {
            this.form3 = fb.group({
                'company_id_filter': [''],
            });
            this.company_id_filter = this.form3.controls['company_id_filter'];

            this.activatedRoute.queryParams.subscribe(params => {
                if (params['id_customer_guide']) {
                    this.params_id_customer_guide = Number(params['id_customer_guide']);
                }
            });

            this.modExportDialog = false;

            this.form4 = fb.group({
                'f4_company_id': [''],
            });
            this.f4_company_id = this.form4.controls['f4_company_id'];
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        /*if (this.customerGuide) {
            this.getProfileSurveisByCustomerguide(this.customerGuide.id);
        } else if (this.params_id_customer_guide) {
            this.getProfileSurveisByCustomerguide(this.params_id_customer_guide);
        } else {
            this.getProfileSurveis();
        }*/
    }

    public loadProfileSurveisLazy(event: LazyLoadEvent) {
        this.customerGuide = null;
        if(this.form3.value.company_id_filter != '')
            this.customerGuide = this.form3.value.company_id_filter.customer_guide;
        if(event.globalFilter != "")
        {
            var str = event.globalFilter;
            event.globalFilter = str.replace(/\s/g, "%");
        }
        this.page = (event.first / this.per_page) + 1;
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort = '-' + event.sortField;
            } else {
                this.sort = event.sortField;
            }
        } else {
            this.sort = '-updated_at';
        }
        if (this.customerGuide) {
            this.getProfileSurveisByCustomerguide(this.customerGuide.id, event.globalFilter);
        } else if (this.params_id_customer_guide) {
            this.getProfileSurveisByCustomerguide(this.params_id_customer_guide, event.globalFilter);
        } else {
            this.getProfileSurveis(event.globalFilter);
        }
    }

    public getProfileSurveis(query?: string, filtersReceived?: any[]) {
        var str=query;
        if (str != null && str != "")
            var query = str.replace(/\s/g, "%");
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.profileSurveyService.getProfileSurvey(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.profileSurveis = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getProfileSurveisByCustomerguide(id: number, query?: string) {
        console.log(id);
        this.profileSurveyService.getProfileSurveyByCustomerGuide(id, this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.profileSurveis = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newProfileSurvey() {
        this.modNew = !this.modNew;
        this.selectProfileSurvey = null;
    }

    public savedProfileSurvey(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectProfileSurvey = null;
        this.modNew = false;
        // this.getProfileSurveis();
    }

    public cancelProfileSurvey (res) {
        this.selectProfileSurvey = null;
        this.modNew = false;
        this.modView = false;
        // this.getProfileSurveis();
    }

    public edit(profileSurvey: ProfileSurvey) {
        this.modNew = true;
        this.selectProfileSurvey = profileSurvey;
        // this.getProfileSurveis();
    }

    public view(profileSurvey: ProfileSurvey) {
        this.openProfileSurvey = true;
        this.selectProfileSurvey = profileSurvey;
        this.profileSurveyID = profileSurvey.id;
        this.modView = true;
    }

    public deleteDialog(profileSurvey: ProfileSurvey) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(profileSurvey);
            }
        });
    }

    public delete(profileSurvey: ProfileSurvey) {
        this.profileSurveyService.deleteProfileSurvey(profileSurvey.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                if (this.customerGuide) {
                    this.getProfileSurveisByCustomerguide(this.customerGuide.id);
                } else if (this.params_id_customer_guide) {
                    this.getProfileSurveisByCustomerguide(this.params_id_customer_guide);
                } else {
                    this.getProfileSurveis();
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeProfileSurvey(profileSurvey: ProfileSurvey) {
        this.putProfileSurvey(profileSurvey);
    }

    public putProfileSurvey(values: ProfileSurvey) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.profileSurveyService.updateProfileSurvey(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filter (values) {
        this.customerGuide = null;
        var query = "";
        var str=this.q_filter.nativeElement.value;
        if (str != null && str != "")
            query = str.replace(/\s/g, "%");
        if (values.company_id_filter) {
            if (values.company_id_filter.customer_guide) {
                this.customerGuide = values.company_id_filter.customer_guide;
            }
        }
        if (this.customerGuide) {
            this.getProfileSurveisByCustomerguide(this.customerGuide.id,query);
        } else if (this.params_id_customer_guide) {
            this.getProfileSurveisByCustomerguide(this.params_id_customer_guide,query);
        } else {
            this.getProfileSurveis(query);
        }
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
        this.form4.reset();
    }

  public exportExcel(values) {
    let url = this.apiUrl + '/profile-surveis/excel?' +
    'token=' + localStorage.getItem('token') +
    '&_sort=customer_guide_id&';

    if (values.f4_company_id) {
      url = url + 'customer_guide_id-in=' + values.f4_company_id.customer_guide.id + '&';
    }

    window.open(url, '_blank');
  }

  downloadTemplateProfileSurvey(){
    window.open(this.apiUrl + '/profile-surveis/downloadTemplateWorkerCare'+ '?token=' + localStorage.getItem('token'));
  }

  printProfileSurvey(ProfileSurvey) {
    window.open(this.apiUrl + '/profile-surveis/' + ProfileSurvey.id + '/pdf?token=' + localStorage.getItem('token'), '_blank');
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/profile-surveis/profile-surveis.component.ts